import React from 'react';
import { FaUserMd, FaUserAlt, FaCalendarAlt, FaIdCard, FaPhone, FaAt, FaMapMarkerAlt, FaVenusMars, FaBirthdayCake, FaStickyNote } from 'react-icons/fa';
import '../styles/PractitionerForm.css';

const PractitionerForm = ({
  practitionerInfo,
  updatePractitionerInfo,
  patientInfo,
  updatePatientInfo,
  appointmentDate,
  handleAppointmentDateChange,
  notes,
  handleNotesChange
}) => {
  // Handle practitioner info changes
  const handlePractitionerChange = (e) => {
    const { name, value } = e.target;
    updatePractitionerInfo({
      ...practitionerInfo,
      [name]: value
    });
  };

  // Handle patient info changes
  const handlePatientChange = (e) => {
    const { name, value } = e.target;
    updatePatientInfo({
      ...patientInfo,
      [name]: value
    });
  };

  // Get current date in YYYY-MM-DD format
  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  return (
    <div className="practitioner-form">
      <div className="form-section animate__animated animate__fadeInUp">
        <h4><FaUserMd /> Praticien</h4>
        <div className="form-group">
          <label><FaIdCard className="me-2 opacity-50" /> Nom</label>
          <input
            type="text"
            name="name"
            className="form-control"
            value={practitionerInfo.name}
            onChange={handlePractitionerChange}
            placeholder="Dr. Nom Prénom"
          />
        </div>
        <div className="form-group">
          <label><FaMapMarkerAlt className="me-2 opacity-50" /> Adresse</label>
          <textarea
            name="address"
            className="form-control"
            rows="2"
            value={practitionerInfo.address}
            onChange={handlePractitionerChange}
            placeholder="Adresse complète du cabinet"
          ></textarea>
        </div>
        <div className="form-row">
          <div className="form-group">
            <label><FaPhone className="me-2 opacity-50" /> Téléphone</label>
            <input
              type="tel"
              name="phone"
              className="form-control"
              value={practitionerInfo.phone}
              onChange={handlePractitionerChange}
              placeholder="Numéro"
            />
          </div>
          <div className="form-group">
            <label><FaAt className="me-2 opacity-50" /> Email</label>
            <input
              type="email"
              name="email"
              className="form-control"
              value={practitionerInfo.email}
              onChange={handlePractitionerChange}
              placeholder="Contact@email.com"
            />
          </div>
        </div>
      </div>

      <div className="form-section animate__animated animate__fadeInUp" style={{ animationDelay: '0.1s' }}>
        <h4><FaUserAlt /> Patient</h4>
        <div className="form-row">
          <div className="form-group">
            <label>Référence</label>
            <input
              type="text"
              name="reference"
              className="form-control"
              value={patientInfo.reference}
              onChange={handlePatientChange}
              placeholder="ID Patient"
            />
          </div>
          <div className="form-group">
            <label>Nom</label>
            <input
              type="text"
              name="name"
              className="form-control"
              value={patientInfo.name}
              onChange={handlePatientChange}
              placeholder="Nom complet"
            />
          </div>
        </div>
        <div className="form-row align-items-end mt-3">
          <div className="form-group mb-0">
            <label><FaVenusMars className="me-2 opacity-50" /> Genre</label>
            <div className="radio-group">
              <div className="radio-item">
                <input
                  type="radio"
                  id="gender-male"
                  name="gender"
                  value="homme"
                  checked={patientInfo.gender === 'homme'}
                  onChange={handlePatientChange}
                />
                <label htmlFor="gender-male">H</label>
              </div>
              <div className="radio-item">
                <input
                  type="radio"
                  id="gender-female"
                  name="gender"
                  value="femme"
                  checked={patientInfo.gender === 'femme'}
                  onChange={handlePatientChange}
                />
                <label htmlFor="gender-female">F</label>
              </div>
            </div>
          </div>
          <div className="form-group mb-0">
            <label><FaBirthdayCake className="me-2 opacity-50" /> Âge</label>
            <input
              type="number"
              name="age"
              className="form-control"
              value={patientInfo.age}
              onChange={handlePatientChange}
              placeholder="Âge"
              min="0"
            />
          </div>
        </div>
      </div>

      <div className="form-section animate__animated animate__fadeInUp" style={{ animationDelay: '0.2s' }}>
        <h4><FaCalendarAlt /> Calendrier</h4>
        <div className="form-row">
          <div className="form-group">
            <label>Date d'envoi</label>
            <input
              type="date"
              className="form-control"
              value={getCurrentDate()}
              disabled
            />
          </div>
          <div className="form-group">
            <label>Date de RDV</label>
            <input
              type="date"
              className="form-control"
              value={appointmentDate}
              onChange={(e) => handleAppointmentDateChange(e.target.value)}
              min={getCurrentDate()}
            />
          </div>
        </div>
      </div>

      <div className="form-section animate__animated animate__fadeInUp" style={{ animationDelay: '0.3s' }}>
        <h4><FaStickyNote /> Remarques / Notes</h4>
        <div className="form-group mb-0">
          <label>Notes sur le cas</label>
          <textarea
            className="form-control"
            rows="3"
            value={notes || ''}
            onChange={(e) => handleNotesChange(e.target.value)}
            placeholder="Notes ou remarques sur le cas (ex: patient pour le remplaçant, consignes particulières...)"
          ></textarea>
        </div>
      </div>
    </div>
  );
};

export default PractitionerForm;
